import React from 'react';
import { Monitor, GraduationCap, Wrench, Calculator } from 'lucide-react';
import { services } from '../mock';

const iconMap = { Monitor, GraduationCap, Wrench, Calculator };

const Services = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 py-16">
      <div className="text-center mb-10">
        <div className="text-xs uppercase tracking-[0.2em] text-[#C75B27] font-medium mb-2">Nos services</div>
        <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-[#1F4D3F]">Au-delà du comparateur</h2>
        <p className="text-[#7A6F5C] mt-3 max-w-2xl mx-auto">
          Comptoir-Online accompagne votre cabinet sur tous les aspects logistiques et de gestion.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {services.map((s) => {
          const Icon = iconMap[s.icon] || Monitor;
          return (
            <a key={s.id} href="#" className="card-hover bg-white border border-[#E8E0D0] rounded-2xl p-6 text-center group">
              <div className="w-14 h-14 rounded-full bg-[#F5F1EA] flex items-center justify-center mx-auto mb-4 group-hover:bg-[#1F4D3F] transition-colors">
                <Icon className="w-7 h-7 text-[#1F4D3F] group-hover:text-white transition-colors" />
              </div>
              <div className="font-serif text-lg font-semibold text-[#2D2A26]">{s.title}</div>
              <div className="text-sm text-[#7A6F5C] mt-1">{s.subtitle}</div>
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default Services;
